import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "twoPeopleFilled"
const TwoPeopleFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M9 14.25Q9.39 14.25 9.75 14.271C14.242 14.528 15.743 17.091 16.246 18.776 16.498 19.624 16.5 20.25 16.5 20.25H1.5S1.5 14.25 9 14.25" />
          <path d="M15 12.75C22.5 12.75 22.5 18.75 22.5 18.75H17.794C17.635 18.098 17.35 17.28 16.834 16.455 15.983 15.091 14.58 13.84 12.393 13.198Q12.549 13.09 12.7 12.97C13.375 12.83 14.138 12.75 15 12.75M9 3.75C9.802 3.75 10.555 3.96 11.207 4.329 12.575 5.1 13.5 6.567 13.5 8.25 13.5 9.141 13.24 9.972 12.793 10.67 11.993 11.92 10.593 12.75 9 12.75 6.515 12.75 4.5 10.735 4.5 8.25S6.515 3.75 9 3.75" />
          <path d="M15 2.25C17.485 2.25 19.5 4.265 19.5 6.75S17.485 11.25 15 11.25Q14.607 11.248 14.232 11.182C14.72 10.315 15 9.316 15 8.25 15 6.13 13.899 4.267 12.238 3.2 13.001 2.606 13.958 2.25 15 2.25" />
        </svg>
      }
    </span>
  )
}
export default TwoPeopleFilledIcon
